let language = {

    BUILDER_PREVIEW_NOT_SUPPORTED_UNCUSTOMIZED_PRODUCTS_ALERT_TITLE: "Currently not supported",
    BUILDER_PREVIEW_NOT_SUPPORTED_UNCUSTOMIZED_PRODUCTS_ALERT_CONTENT: "The uncustomized products do not support preview for the time being.",
    BUILDER_PREVIEW:"Preview"

};
export { language }